import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  @Input() errorMessage: string = '';
  @Input() errorCode: string = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Verifica se há dados na rota e os usa se os inputs não estiverem definidos
    this.route.data.subscribe(data => {
      if (data && !this.errorMessage) {
        this.errorMessage = data['errorMessage'] || '';
      }
      if (data && !this.errorCode) {
        this.errorCode = data['errorCode'] || '';
      }
    });

    // Verifica se há query params e os usa se os inputs não estiverem definidos
    this.route.queryParams.subscribe(params => {
      if (params && !this.errorMessage && params['message']) {
        this.errorMessage = params['message'];
      }
      if (params && !this.errorCode && params['code']) {
        this.errorCode = params['code'];
      }
    });
  }
}
